import { z } from 'zod';

const totalsSchema = z.object({
    logins_total: z.number().nonnegative().default(0),
    mails_total: z.number().nonnegative().default(0),
    reservations_total: z.number().nonnegative().default(0),
});

const last30DaysSchema = z.object({
    logins_30d: z.number().nonnegative().default(0),
    mails_30d: z.number().nonnegative().default(0),
    reservations_30d: z.number().nonnegative().default(0),
});

const seriesLast30DaysSchema = z.object({
    labels: z.array(z.string()).default([]),
    logins: z.array(z.number().nonnegative()).default([]),
    mails: z.array(z.number().nonnegative()).default([]),
    reservations: z.array(z.number().nonnegative()).default([]),
});

export const statisticsSchema = z
    .preprocess((rawValue) => {
        if (!rawValue || typeof rawValue !== 'object') {
            return rawValue;
        }

        const obj = rawValue as {
            totals?: {
                logins_total?: number;
                registrations_total?: number;
                mails_total?: number;
                reservations_total?: number;
            };
            last_30_days?: {
                logins_30d?: number;
                registrations_30d?: number;
                mails_30d?: number;
                reservations_30d?: number;
            };
            series_last_30_days?: {
                labels?: string[];
                logins?: number[];
                registrations?: number[];
                mails?: number[];
                reservations?: number[];
            };
        };

        return {
            totals: {
                logins_total: obj.totals?.logins_total ?? obj.totals?.registrations_total ?? 0,
                mails_total: obj.totals?.mails_total ?? 0,
                reservations_total: obj.totals?.reservations_total ?? 0,
            },
            last_30_days: {
                logins_30d: obj.last_30_days?.logins_30d ?? obj.last_30_days?.registrations_30d ?? 0,
                mails_30d: obj.last_30_days?.mails_30d ?? 0,
                reservations_30d: obj.last_30_days?.reservations_30d ?? 0,
            },
            series_last_30_days: {
                labels: obj.series_last_30_days?.labels ?? [],
                logins: obj.series_last_30_days?.logins ?? obj.series_last_30_days?.registrations ?? [],
                mails: obj.series_last_30_days?.mails ?? [],
                reservations: obj.series_last_30_days?.reservations ?? [],
            },
        };
    }, z.object({
        totals: totalsSchema,
        last_30_days: last30DaysSchema,
        series_last_30_days: seriesLast30DaysSchema,
    }));

export type IStatistics = z.infer<typeof statisticsSchema>;
